/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/heart_rate'
export default icon
